import React from 'react'
import ProdIOTIssMatRow from './ProdIOTIssMatRow'
import FormLabel from '../../../../../library/form/components/FormLabel';
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import useRowSelector from "../../../../../library/hooks/selector/useRowSelector";
import { UiView, UiViewContent } from "../../../../../library/layout/Index";
import * as fn from "../../../../../helper/uiFunctions";

//ISSUE MATERIAL
const ProdIOTIssMat = (props) => {
    const { formObject, viewData } = props;

    const rowSelector = useRowSelector("2", null);
    let matIndex = 0, sfIndex = 0;

    const renderItemToIssue = (row, index) => {
        if (fn.compareNumber(row.rowValues.isIssueMore.val, 0)) {
            return (
                <li><ProdIOTIssMatRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} rowSelector={rowSelector} index={++matIndex} /></li>
            )
        }
        else {
            return (null);
        }
    }

    const renderItemToIssueMore = (row, index) => {
        if (fn.compareNumber(row.rowValues.isIssueMore.val, 1)) {
            return (
                <li><ProdIOTIssMatRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} rowSelector={rowSelector} index={++sfIndex} /></li>
            )
        }
        else {
            return (null);
        }
    }


    return (
        <UiView>
            <UiViewContent>
                <ul className="uiListTable">
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No." /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Item Id" /></li>
                            <li className="uiColumnCenter uiColumn200"><SarasTrans value="Item Name" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                                action={{ paramName: "variation1Name" }} >
                                <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                                action={{ paramName: "variation2Name" }} >
                                <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                            </FormWrapper>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Qty Available" /></li>
                            <li className="uiColumnCenter uiColumn130"><SarasTrans value="Qty To Issue" /></li>
                            <li className="uiColumnCenter uiColumn100"><SarasTrans value="Remark" /></li>
                        </ul>
                    </li>
                    {
                        Object.values(viewData ? viewData : {}).map((row, index) => (
                            renderItemToIssue(row, index)
                        ))
                    }
                </ul>
            </UiViewContent>
            <UiViewContent>
                <ul className="uiListTable uiSpacer20">
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No." /></li>
                            <li className="uiColumnCenter uiColumn100"><SarasTrans value="Item Id" /></li>
                            <li className="uiColumnCenter uiColumn200"><SarasTrans value="Item Name" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                                action={{ paramName: "variation1Name" }} >
                                <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                                action={{ paramName: "variation2Name" }} >
                                <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                            </FormWrapper>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Qty Available" /></li>
                            <li className="uiColumnCenter uiColumn130"><SarasTrans value="Qty Issued" /></li>
                            <li className="uiColumnCenter uiColumn100"><SarasTrans value="Remark" /></li>
                        </ul>
                    </li>
                    {
                        Object.values(viewData ? viewData : {}).sort((a, b) => a.sortKey - b.sortKey).map((row, index) => (
                            renderItemToIssueMore(row, index)
                        ))
                    }
                </ul>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ProdIOTIssMat, "prodIOTIssMat", "prodIOSum");
